// extracted by mini-css-extract-plugin
module.exports = {"hidden":"v4Notice_hidden__LKKMw","textEmphasis":"v4Notice_textEmphasis__cdPFn","noticeText":"v4Notice_noticeText__5Luwd"};